var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { EmbedBlockElement } from '../_common/embed-block-helper/embed-block-element.js';
let EmbedGithubBlock = class EmbedGithubBlock extends EmbedBlockElement {
    render() {
        return this.renderEmbed(() => {
            return html `
        <div class="affine-embed-github-block">
          <h3>GitHub Card</h3>
          <div>${this.model.owner}/${this.model.repo}</div>
        </div>
      `;
        });
    }
};
EmbedGithubBlock.styles = css `
    .affine-embed-github-block {
      display: block;
      height: 100%;
      width: 100%;
      background: var(--affine-background-primary-color);
      border: 1px solid var(--affine-border-color);
      padding: 12px;
    }
    affine-embed-github-block {
      display: block;
      width: 100%;
      height: 100%;
    }
    * + affine-embed-github-block {
      margin-top: 12px;
    }
  `;
EmbedGithubBlock = __decorate([
    customElement('affine-embed-github-block')
], EmbedGithubBlock);
export { EmbedGithubBlock };
//# sourceMappingURL=embed-github-block.js.map